import useReducer from '@store/useReducer'
import * as AuthStore from '@store/auth/auth'

import { AuthScope } from '@api/enum'

export type Filter =
  | 'manifestation'
  | 'activity'
  | 'societe'
  | 'status'
  | 'category'
  | 'location'
  | 'user'
  | 'created'
  | 'followed'
  | 'new'
  | 'open'
  | 'map'
  | 'prioritaire'
  | 'from'
  | 'to'

// by default, all filters actives
const defaultDisplay: Filter[] = [
  'manifestation',
  'activity',
  'societe',
  'status',
  'category',
  'location',
  'user',
  'created',
  'followed',
  'new',
  'open',
  'map',
  'prioritaire',
  'from',
  'to',
]

const useFilterDisplay = (initial = defaultDisplay) => {
  const scopes = useReducer(AuthStore.store, (s) => s.scopes)

  const UserFilterRule: Filter[] =
    scopes.includes(AuthScope.FiltresUtilisateursDeclarant) || scopes.includes(AuthScope.FiltresUtilisateursSociete)
      ? []
      : ['user']

  const SocieteFilterRule: Filter[] = scopes.includes(AuthScope.FiltresSocietesLecture) ? [] : ['societe']

  return initial.filter((f) => !UserFilterRule.includes(f)).filter((f) => !SocieteFilterRule.includes(f))
}

export default useFilterDisplay
